var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/compose/components/upload-progress.tsx";
import React from 'react';
import UploadProgress from 'soapbox/components/upload-progress';
import { useCompose } from 'soapbox/hooks';

/** File upload progress bar for post composer. */
const ComposeUploadProgress = _ref => {
  let {
    composeId
  } = _ref;
  const compose = useCompose(composeId);
  const active = compose.is_uploading;
  const progress = compose.progress;

  if (!active) {
    return null;
  }

  return /*#__PURE__*/React.createElement(UploadProgress, {
    progress: progress,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 5
    }
  });
};

export default ComposeUploadProgress;